'use client';

import _slicedToArray from "/codebuild/output/src218/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useRef, useState, useEffect } from 'react';
import { clamp } from '../utils/clamp/clamp.mjs';
function clampUseMovePosition(position) {
  return {
    x: clamp(position.x, 0, 1),
    y: clamp(position.y, 0, 1)
  };
}
function useMove(onChange, handlers) {
  var dir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ltr";
  var ref = useRef(null);
  var mounted = useRef(false);
  var isSliding = useRef(false);
  var frame = useRef(0);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  useEffect(function () {
    mounted.current = true;
  }, []);
  useEffect(function () {
    var _ref$current, _ref$current2;
    var onScrub = function onScrub(_ref) {
      var x = _ref.x,
        y = _ref.y;
      cancelAnimationFrame(frame.current);
      frame.current = requestAnimationFrame(function () {
        if (mounted.current && ref.current) {
          ref.current.style.userSelect = "none";
          var rect = ref.current.getBoundingClientRect();
          if (rect.width && rect.height) {
            var _x = clamp((x - rect.left) / rect.width, 0, 1);
            onChange({
              x: dir === "ltr" ? _x : 1 - _x,
              y: clamp((y - rect.top) / rect.height, 0, 1)
            });
          }
        }
      });
    };
    var bindEvents = function bindEvents() {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", stopScrubbing);
      document.addEventListener("touchmove", onTouchMove);
      document.addEventListener("touchend", stopScrubbing);
    };
    var unbindEvents = function unbindEvents() {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", stopScrubbing);
      document.removeEventListener("touchmove", onTouchMove);
      document.removeEventListener("touchend", stopScrubbing);
    };
    var startScrubbing = function startScrubbing() {
      if (!isSliding.current && mounted.current) {
        isSliding.current = true;
        typeof (handlers === null || handlers === void 0 ? void 0 : handlers.onScrubStart) === "function" && handlers.onScrubStart();
        setActive(true);
        bindEvents();
      }
    };
    var stopScrubbing = function stopScrubbing() {
      if (isSliding.current && mounted.current) {
        isSliding.current = false;
        setActive(false);
        unbindEvents();
        setTimeout(function () {
          typeof (handlers === null || handlers === void 0 ? void 0 : handlers.onScrubEnd) === "function" && handlers.onScrubEnd();
        }, 0);
      }
    };
    var onMouseDown = function onMouseDown(event) {
      startScrubbing();
      event.preventDefault();
      onMouseMove(event);
    };
    var onMouseMove = function onMouseMove(event) {
      return onScrub({
        x: event.clientX,
        y: event.clientY
      });
    };
    var onTouchStart = function onTouchStart(event) {
      if (event.cancelable) {
        event.preventDefault();
      }
      startScrubbing();
      onTouchMove(event);
    };
    var onTouchMove = function onTouchMove(event) {
      if (event.cancelable) {
        event.preventDefault();
      }
      onScrub({
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY
      });
    };
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.addEventListener("mousedown", onMouseDown);
    (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.addEventListener("touchstart", onTouchStart, {
      passive: false
    });
    return function () {
      if (ref.current) {
        ref.current.removeEventListener("mousedown", onMouseDown);
        ref.current.removeEventListener("touchstart", onTouchStart);
      }
    };
  }, [dir, onChange]);
  return {
    ref: ref,
    active: active
  };
}
export { clampUseMovePosition, useMove };